"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _useSanity2 = _interopRequireDefault(require("./useSanity"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SanityList = function SanityList(_ref) {
  var type = _ref.type,
      children = _ref.children;

  var _useSanity = (0, _useSanity2["default"])(),
      getType = _useSanity.getType,
      types = _useSanity.types;

  var documents = types[type] || [];
  (0, _react.useEffect)(function () {
    getType(type);
  }, [type]);
  return (0, _react.useMemo)(function () {
    return children(documents);
  }, [documents.length]);
};

var _default = SanityList;
exports["default"] = _default;
SanityList.propTypes = {
  children: _propTypes["default"].func,
  type: _propTypes["default"].string
};